import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Home, Compass, Bell, User } from "lucide-react";

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const go = (to) => navigate(to);
  const openActivity = () => {
    if (!user) { navigate("/"); return; }
    window.dispatchEvent(new Event("fv-open-notifications"));
  };

  const items = [
    { icon: Home, label: "Home", onClick: () => go("/"), active: path === "/" },
    { icon: Compass, label: "Explore", onClick: () => go("/"), active: false },
    { icon: Bell, label: "Activity", onClick: openActivity, active: false },
    { icon: User, label: "Profile", onClick: () => go(user ? `/profile/${user.user_id}` : "/"), active: path.startsWith("/profile") },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-gray-100 lg:hidden z-50 pb-safe" data-testid="bottom-nav">
      <div className="flex justify-around items-center h-14">
        {items.map((item) => (
          <button
            key={item.label}
            onClick={item.onClick}
            className={`flex flex-col items-center gap-0.5 px-4 py-1 transition-colors ${item.active ? "text-view-a" : "text-neutral hover:text-dark"}`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5" strokeWidth={item.active ? 2.5 : 1.5} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
